import { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import { Badge, Button, UncontrolledTooltip, TabContent } from 'reactstrap'
import './CarDetail.css'
import { CarInfoQuery } from './Queries'
import ReservationModalNew from "../../Reservations/Modals/ReservationModalNew"
import toTitleCase from '../../Functions/toTitleCase'
import { Nav, NavItem, NavLink, } from 'reactstrap'
import OverviewTabWrapper from './OverviewTabWrapper'
import InsuranceTabWrapper from './InsuranceTab/InsuranceTabWrapper'
import PricingTab from "./PricingTab/PricingTab"
import EquipmentsTab from "./EquipmentTab/EquipmentTab"
import DocumentsTab from "./DocumentTab/DocumentsTab"
import TrackersTabWrapper from "./TrackersTab/TrackersTabWrapper"
import CarIssuesTabContainer from "./CarIssuesTab/CarIssuesTabContainer"
import renderEnumToInt from '../../Functions/renderEnumToInt'
import DeleteCarModal from "./DeleteCarModal"
import moment from "moment"
import CopyToClipboard from "../../Material/CopyToClipboard"
import InspectionTab from "./InspectionTab/InspectionTab"
import { cleanDocumentUrl } from "../../Material/DocumentModal/DocumentsListNew"
import DocumentModalNew from "../../Material/DocumentModal/DocumentModalNew"
import { HasPermissionsQuery } from "../../Functions/querys"
import RentalTab from '../../Material/RentalTab/RentalTab'
import ScopedTabPane from '../../Filters/ScopedTabPane'
import DashcamContainer from '../../Material/DashcamContainer'
import withApolloClient from '../../withApolloClient'
import AddNewIncidentModal from "../../Incidents/IncidentModals/AddNewIncidentModal"

const CAR_DETAIL_PAGE_TABS = [
    { id: "#overview", name: "OVERVIEW", queryParams: false },
    { id: "#rentals", name: "RENTALS", queryParams: false },
    { id: "#insurance", name: "INSURANCE", queryParams: false },
    { id: "#documents", name: "DOCUMENTS", queryParams: false },
    { id: "#pricing", name: "PRICING", queryParams: false },
    { id: "#equipments", name: "EQUIPMENTS", queryParams: false },
    { id: "#telematics", name: "TELEMATICS", queryParams: false },
    { id: "#issues", name: "ISSUES", queryParams: false },
    { id: "#inspections", name: "INSPECTIONS", queryParams: true },
    { id: "#dashcamrecordings", name: "DASHCAM", queryParams: true, requiredPermission: "view_dashcamrecord" },
]

class CarDetailContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeIndex: 0,
            newView: true,
            activeReservation: this.props.car &&
                this.props.car.carReservation &&
                this.props.car.carReservation.edges &&
                this.props.car.carReservation.edges.length > 0 ?
                this.props.car.carReservation.edges.find(reservation => reservation.node.status === "Open") : null,
            tab: "overview"
        }
    }
    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.car !== this.props.car) {
            let activeReservation = this.props.car && this.props.car.carReservation && this.props.car.carReservation.edges.length > 0 ? this.props.car.carReservation.edges.find(reservation => reservation?.node?.status === "Open") : null
            this.setState({ activeReservation })
        }
        if (this.state.tab !== prevState.tab) {
            this.props.navigate({ hash: this.state.tab, search: CAR_DETAIL_PAGE_TABS.filter(obj => obj.queryParams).map(obj => obj.id).includes(this.state.tab) && this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes(this.state.tab) ? window.location.search : "" })
        }
    }
    toggleTab = (tabId) => {
        if (!this.state.rendererdTabPanes.includes(tabId)) {
            this.setState({ rendererdTabPanes: [...this.state.rendererdTabPanes, tabId] })
        }
        this.props.navigate({ hash: this.state.tab })
        this.setState({ tab: tabId })
    }

    componentDidMount() {
        let defaultTab = CAR_DETAIL_PAGE_TABS[0].id
        if (window.location.hash && CAR_DETAIL_PAGE_TABS.map(item => item.id).includes(window.location.hash)) {
            this.setState({ tab: window.location.hash, rendererdTabPanes: [window.location.hash] })
        } else {
            window.location.hash = defaultTab
            this.setState({ tab: defaultTab, rendererdTabPanes: [defaultTab] })
        }

    }
    viewImages(picturesObject) {
        let tmpArr = []
        if (picturesObject && picturesObject.length > 0) {
            const toBeAdded = picturesObject.map((pic, i) => ({ id: pic.node.id, documentUrl: cleanDocumentUrl(pic.node.pictureUrl), description: pic.node.description, dateAdded: pic.node.dateAdded, name: pic.node.pictureType }))
            tmpArr = [...tmpArr, ...toBeAdded]
        }
        this.setState({ checkoutPictures: tmpArr, selectedImage: tmpArr[0] })
        this.toggleModal("checkoutPicturesModal")
    }
    next = () => {
        const checkoutPictures = this.state.checkoutPictures
        const currentIndex = checkoutPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === checkoutPictures.length - 1) return
        this.setState({ selectedImage: checkoutPictures[currentIndex + 1] })
    }

    prev = () => {
        const checkoutPictures = this.state.checkoutPictures
        const currentIndex = checkoutPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === 0) return
        this.setState({ selectedImage: checkoutPictures[currentIndex - 1] })
    }
    render() {
        const permissions = this.props?.hasPermissions ?? []
        return (
            <div className="car-detail-container">

                {this.state.openModal === "checkoutPicturesModal" &&
                    <DocumentModalNew
                        document={this.state.selectedImage}
                        handleClose={() => this.setState({ selectedImage: null, openModal: "" })}
                        next={this.next}
                        prev={this.prev}
                        objectType={"car"}
                        isPicture={true}
                        currentUser={this.props.currentUser}
                    />
                }
                <div>
                    <div>
                        {this.props.car && <>
                            <div className="car-header">
                                <span className="car-id-wrapper">
                                    #{this.props.car.pk}
                                </span>
                                <div className="car-image">
                                    <i className="fa fa-2x fa-car" aria-hidden="true"></i>
                                </div>
                                <div>
                                    <p className="car-name">
                                        <label>
                                            {this.props.car && this.props.car.carModel ?
                                                this.props.car.year + " " + toTitleCase(this.props.car.carModel.make) + " " + toTitleCase(this.props.car.carModel.name) : ""
                                            }
                                            &nbsp;
                                            <small>
                                                {this.props.car && this.props.car.carModel && this.props.car.carModel.groupType ? this.props.car.carModel.groupType.name : ""}
                                            </small>
                                        </label>
                                        &nbsp;&nbsp;
                                        {this.props.car && this.props.car.hasTracker ?
                                            (this.props.car.trackerStatus === "Disabled" ? <Badge className="danger">Disabled</Badge> :
                                                this.props.car.trackerStatus === "Repo" && <Badge className="warning">Repo</Badge>)
                                            : <Badge className="black">No tracker</Badge>
                                        }
                                    </p>
                                </div>
                                <div>
                                    <p className="header-detail">{this.props.car && this.props.car.vin ? this.props.car.vin : "--"}&nbsp;&nbsp;<CopyToClipboard textToCopy={this.props.car && this.props.car.vin ? this.props.car.vin : "--"} displayText={"vin"} /></p>
                                </div>
                                <div>
                                    <p className="header-detail">{this.props.car && this.props.car.dmvPlate ? this.props.car.dmvPlate : "--"}&nbsp;&nbsp;<CopyToClipboard textToCopy={this.props.car && this.props.car.dmvPlate ? this.props.car.dmvPlate : "--"} displayText={"dmv plate"} /></p>
                                </div>
                                <div>
                                    <span className="bos-badge bos-badge-blue">{this.props.car && this.props.car.branch ? this.props.car.branch.name : "--"}</span>&nbsp;
                                    <Badge color="black" className="black">STAGE: {this.props.car ? this.props.car.stageDisplay : "--"}</Badge>
                                </div>
                                <div className="text-success header-detail reserve-car">
                                    {this.state.openModal === "NewReservationModal" &&
                                        <ReservationModalNew
                                            handleClose={() => this.toggleModal("")}
                                            open={this.state.openModal === "NewReservationModal"}
                                            title={"Create New Reservation"}
                                            refetchQuery={this.props.refetchCarQuery}
                                            skip={true}
                                            carId={this.props.car.id}
                                        />
                                    }
                                    {this.props.car && !this.props.car.currentAgreement && !this.state.activeReservation &&
                                        <Button className="ghost mr-2"><a onClick={() => this.toggleModal("NewReservationModal")}>RESERVE NOW | <i className="fa fa-lg fa-calendar-o" aria-hidden="true"></i></a></Button>
                                    }

                                    {(permissions?.includes("custom_can_add_incident_without_inspection") || [4, 5, 6, 7, 8, 9, 13, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 29, 31, 33, 36, 37, 44, 47, 48, 50, 51, 59, 60, 61, 62, 63, 73, 74, 75, 76, 77, 78, 82, 83, 84, 85, 86, 87, 88, 91, 94, 95, 96, 97, 98, 99].includes(this.props.car?.branch?.pk)) && <Button id="createNewIncident" className="ghost" onClick={() => this.toggleModal("createNewIncident")}>
                                        REPORT INCIDENT | <i className="fa fa-plus" aria-hidden="true"></i>
                                    </Button>}&nbsp;&nbsp;&nbsp;
                                    {this.state.openModal === "createNewIncident" &&
                                        <AddNewIncidentModal
                                            isOpen={this.state.openModal === "createNewIncident"}
                                            toggle={() => this.toggleModal("")}
                                            carId={this.props.car.id}
                                            branchId={this.props.car?.branch?.id}
                                        />
                                    }
                                </div>
                                {this.props.car && this.props.car.lastCheckout && this.props.car.lastCheckout.carpicturesSet && this.props.car.lastCheckout.carpicturesSet.edges && this.props.car.lastCheckout.carpicturesSet.edges.length > 0 && <>
                                    <i className="fa fa-file-image-o fa-lg mt-auto mb-2" id={"viewCheckoutImages"} aria-hidden="true" onClick={() => this.viewImages(this.props.car.lastCheckout.carpicturesSet.edges)}></i>
                                    <UncontrolledTooltip placement="top" target={"viewCheckoutImages"}>Checkout Pictures @ {moment(this.props.car.lastCheckout.dateAdded).tz("America/New_York").format("lll")}</UncontrolledTooltip>
                                </>}
                                {this.props.car && this.props.car.canDelete && permissions?.includes("delete_car") &&
                                    <div className="float-right">
                                        <Button color="danger" id="delete-car" style={{ cursor: "pointer" }} onClick={() => this.toggleModal("deleteCarModal")} ><i className="fa fa-lg fa-trash" aria-hidden="true"></i></Button>
                                        {this.state.openModal === "deleteCarModal" &&
                                            <DeleteCarModal
                                                handleClose={() => this.toggleModal("")}
                                                open={this.state.openModal === "deleteCarModal"}
                                                car={this.props.car}

                                            />
                                        }
                                        <UncontrolledTooltip placement="top" target="delete-car">Delete Car</UncontrolledTooltip>
                                    </div>
                                }
                            </div>
                        </>
                        }
                    </div>
                    <div className="car-detail">
                        <Nav tabs>
                            {CAR_DETAIL_PAGE_TABS.filter(
                                item => !item.requiredPermission || (item.requiredPermission && permissions?.includes(item.requiredPermission))
                            )
                                .map(item =>
                                    <NavItem key={item.id} className={this.state.tab === item.id ? "active" : "inactive"}>
                                        <NavLink className={this.state.tab === item.id ? "active" : "inactive"} onClick={() => this.toggleTab(item.id)}>
                                            {item.name}
                                        </NavLink>
                                    </NavItem>
                                )}
                        </Nav>
                        <TabContent activeTab={this.state.tab}>
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#overview") && <ScopedTabPane activeTab={this.state.tab} tabId="#overview">
                                <OverviewTabWrapper {...this.props} currentUser={this.props.currentUser} />
                            </ScopedTabPane>}
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#documents") && <ScopedTabPane activeTab={this.state.tab} tabId="#documents">
                                <DocumentsTab currentUser={this.props.currentUser} id={this.props.car && this.props.car.id} />
                            </ScopedTabPane>}
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#insurance") && <ScopedTabPane activeTab={this.state.tab} tabId="#insurance">
                                <InsuranceTabWrapper id={this.props.car && this.props.car.id} {...this.props} currentUser={this.props.currentUser} />
                            </ScopedTabPane>}
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#rentals") && <ScopedTabPane activeTab={this.state.tab} tabId="#rentals">
                                <RentalTab currentUser={this.props.currentUser} carId={parseInt(this.props?.params?.pk)} {...this.props} viewType="car" />
                            </ScopedTabPane>}
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#pricing") && <ScopedTabPane activeTab={this.state.tab} tabId="#pricing">
                                <PricingTab id={this.props.car && this.props.car.id} currentUser={this.props.currentUser} />
                            </ScopedTabPane>}
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#equipments") && <ScopedTabPane activeTab={this.state.tab} tabId="#equipments">
                                <EquipmentsTab {...this.props} currentUser={this.props.currentUser} />
                            </ScopedTabPane>}
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#telematics") && <ScopedTabPane activeTab={this.state.tab} tabId="#telematics">
                                <TrackersTabWrapper {...this.props} currentUser={this.props.currentUser} />
                            </ScopedTabPane>}
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#issues") && <ScopedTabPane activeTab={this.state.tab} tabId="#issues">
                                <CarIssuesTabContainer id={this.props.car && this.props.car.id} {...this.props} currentUser={this.props.currentUser} />
                            </ScopedTabPane>}
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#inspections") && <ScopedTabPane activeTab={this.state.tab} tabId="#inspections">
                                <InspectionTab id={this.props.car && this.props.car.id} {...this.props} activeTab={this.state.tab.slice(1)} currentUser={this.props.currentUser} />
                            </ScopedTabPane>}
                            {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#dashcamrecordings") && <ScopedTabPane activeTab={this.state.tab} tabId="#dashcamrecordings">
                                <DashcamContainer carId={this.props?.car?.id} />
                            </ScopedTabPane>}
                        </TabContent>
                    </div>
                </div >
            </div >
        )
    }
}


//-----------------------------------
export default graphql(HasPermissionsQuery, {
    options: () => ({
        variables: { userPermissions: ["delete_car", "view_dashcamrecord", "custom_can_add_incident_without_inspection"] },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions,
        loading,
        variables,
    })
})(
    graphql(CarInfoQuery, {
        options: (props) => ({

            variables: { pk: parseInt(props.params.pk) },
        }),
        props: ({ data: { car, loading, refetch, variables } }) => ({
            car,
            loading,
            variables,
            refetchCarQuery: () => {
                return refetch({
                    query: CarInfoQuery,
                    variables: {
                        ...variables,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return { car: fetchMoreResult.car }
                    },
                })
            },
        })
    })(
        withApolloClient(CarDetailContainer)
    )
)
